var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"href":"/admin/login_info","variant":"primary"}},[_vm._v("発行済みログイン情報")])}
var staticRenderFns = []

export { render, staticRenderFns }